<template>
  <div class="cancel-learning">
    <div
      v-if="isShowDropBox"
      class="cancel-learning-drop-box-mask"
      @click="hideDropBox"
    ></div>
    <div class="cancel-learning-main-btn">
      <button
        class="cancel-learning-btn normal"
        v-if="!isJoinUserLearning"
        @click="joinUserLearning"
      >
        <icon type="join"></icon>
        加入我的学习
      </button>
      <button class="cancel-learning-btn grey" @click="showDropBox()" v-else>
        <icon type="menu-grey"></icon>
        已加入学习
      </button>
    </div>
    <div v-if="isShowDropBox" class="cancel-learning-drop-box">
      <div class="cancel-learning-drop-box-item" @click="cancelUserLearning">
        取消加入学习
      </div>
      <template v-if="isAllowUserLearningGlobalPush">
        <div
          v-if="isAllowUserLearningPush"
          class="cancel-learning-drop-box-item"
          @click="cancelUserLearningPush"
        >
          关闭提醒-此课程的学习提醒
        </div>
        <div
          v-else
          class="cancel-learning-drop-box-item"
          @click="openUserLearningPush"
        >
          开启此课程的学习提醒
        </div>
        <div
          class="cancel-learning-drop-box-item"
          @click="cancelUserLearningGlobalPush"
        >
          关闭提醒-<span class="hint">所有已加入课程的学习提醒</span>
        </div>
      </template>
      <div v-else class="cancel-learning-drop-box-item" @click="openUserLearningGlobalPush">开启提醒</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isJoinUserLearning: Boolean,
    isAllowUserLearningPush: Boolean,
    isAllowUserLearningGlobalPush: Boolean,
    sid: [Number, String],
    currentId: [Number, String],
    handleJoinUserLearningSuccess: Function,
    handleCancelUserLearningSuccess: Function,
    handleChangeIsAllowPush: Function,
    handleChangeIsAllowGlobalPush: Function,
  },

  data() {
    return {
      isShowDropBox: false,
    };
  },
  methods: {
    joinUserLearning() {
      this.reportClick('subscribe');
      if (!this.$checkAuth()) {
        return;
      }

      this.$service.learning
        .joinUserLearning(this.currentId, this.sid)
        .then((res) => {
          if (res.code === 200) {
            this.$toast.success('加入我的学习成功');
            this.handleJoinUserLearningSuccess();
          } else {
            this.$toast(res.msg);
          }
        });
    },
    openUserLearningGlobalPush() {
      this.reportClick('open_all');
      this.$service.learning
        .changeUserLearningGlobalPushStatus(1)
        .then((res) => {
          if (res.code === 200) {
            this.$toast.success('开启提醒成功');
            this.hideDropBox();
            this.handleChangeIsAllowGlobalPush(true);
          } else {
            this.$toast(res.msg);
          }
        });
    },

    cancelUserLearningGlobalPush() {
      this.reportClick('off_all');
      this.$service.learning
        .changeUserLearningGlobalPushStatus(2)
        .then((res) => {
          if (res.code === 200) {
            this.$toast.success('关闭提醒成功');
            this.hideDropBox();
            this.handleChangeIsAllowGlobalPush(false);
          } else {
            this.$toast(res.msg);
          }
        });
    },

    openUserLearningPush() {
      this.$service.learning
        .changeUserLearningPushStatus(this.sid, 1)
        .then((res) => {
          if (res.code === 200) {
            this.$toast.success('开启提醒成功');
            this.hideDropBox();
            this.handleChangeIsAllowPush(true);
          } else {
            this.$toast(res.msg);
          }
        });
    },

    cancelUserLearningPush() {
      this.reportClick('off_one');
      this.$service.learning
        .changeUserLearningPushStatus(this.sid, 2)
        .then((res) => {
          if (res.code === 200) {
            this.$toast.success('关闭提醒成功');
            this.hideDropBox();
            this.handleChangeIsAllowPush(false);
          } else {
            this.$toast(res.msg);
          }
        });
    },
    reportClick(click) {
      this.$collect.detailsSkillvideoClick({
        click,
        type: this.currentId,
        series: this.sid,
      });
    },

    cancelUserLearning() {
      this.reportClick('cancel');
      this.$service.learning.cancelUserLearning(this.sid).then((res) => {
        if (res.code === 200) {
          this.$toast.success('取消加入成功');
          this.hideDropBox();
          this.handleCancelUserLearningSuccess();
        } else {
          this.$toast(res.msg);
        }
      });
    },

    showDropBox() {
      this.isShowDropBox = true;
    },

    hideDropBox() {
      this.isShowDropBox = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.cancel-learning {
  &-drop-box-mask {
    position: fixed;
    top: 56px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: 99;
  }
  &-main-btn {
    .normal {
      background: #417ff9;
      color: #ffffff;
    }
    .grey {
      background: #f2f3f5;
      color: #b9bdc6;
    }
  }
  &-btn {
    width: 100%;
    height: 34px;
    border-radius: 18px;
    border: none;
    outline: none;
    font-size: 14px;
    line-height: 20px;
    cursor: pointer;
  }

  &-drop-box {
    margin-top: 4px;
    z-index: 100;
    width: 250px;
    padding: 4px;
    border-radius: 8px;
    border: 1px solid rgba(17, 19, 23, 0.1);
    background-color: white;
    box-shadow: 0px 12px 24px 0px rgba(17,19,23,0.2);
    position: absolute;
    z-index: 999;
    &-item {
      width: 100%;
      height: 28px;
      line-height: 20px;
      color: #333840;
      font-size: 12px;
      height: 28px;
      padding-left: 8px;
      padding-top: 5px;
      padding-bottom: 3px;
      cursor: pointer;
      &:hover {
        background: rgba(8, 48, 93, 0.04);
      }
      .hint {
        color: #e65449;
      }
    }
  }
}
</style>
